import { CommentController } from './PostController';

// Reusable pagination helper for post comments that delegates to figshelf-modules
class CommentFeedController {
  constructor(apiService, postId = null, take = 20) {
    this.commentCtl = new CommentController(apiService);
    this.postId = postId;
    this.take = take;
    this.skip = 0;
    this.items = [];
    this.hasMore = true;
    this.loading = false;
  }

  setPost(postId) {
    this.postId = postId;
  }

  async reset(postId) {
    if (postId) this.postId = postId;
    if (!this.postId) return [];
    this.skip = 0;
    this.items = [];
    this.hasMore = true;
    return this.loadMore();
  }

  async loadMore() {
    if (!this.postId || this.loading || !this.hasMore) return this.items;
    this.loading = true;
    try {
      const res = (await (this.commentCtl.getComments?.(this.postId, this.take, this.skip)
        || this.commentCtl.getParentComments?.(this.postId, this.skip, this.take)));
      const payload = res?.data ?? res;
      const list = Array.isArray(payload)
        ? payload
        : payload?.items || payload?.comments || payload?.data || [];
      const normalized = Array.isArray(list) ? list : [];
      this.items = [...this.items, ...normalized];
      this.skip += normalized.length;
      this.hasMore = normalized.length >= this.take;
      return this.items;
    } finally {
      this.loading = false;
    }
  }

  async add(content) {
    if (!this.postId) return null;
    const res = await (this.commentCtl.addComment?.(this.postId, { content })
      || this.commentCtl.createComment(this.postId, { content }));
    return res;
  }
}

export default CommentFeedController;
